import React, { useState } from "react";
import { Link } from "react-router-dom";
import menuIcon from "../../../assets/menu/menu.svg";
import closeIcon from "../../../assets/menu/close.svg";

import LogoTextFlama from "../../../assets/logo-text-flama";

import "./Menu.css";

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button
        className="burger"
        onClick={toggleMenu}
        style={{
          backgroundImage: `url(${isOpen ? closeIcon : menuIcon})`,
        }}
      ></button>
      <div className={`menu ${isOpen ? "open" : ""}`}>
        <Link to="/" onClick={toggleMenu} className="menu__header-logo link-without-underline">
          <LogoTextFlama fillColor="#5abd63" width={160} />
        </Link>
        <ul>
          <li style={{ animationDelay: "0.4s" }}>
            <Link to="/" onClick={toggleMenu}>
              Inici
            </Link>
          </li>
          <li style={{ animationDelay: "0.4s" }}>
            <Link to="/qui-som" onClick={toggleMenu}>
              Qui som
            </Link>
          </li>
          <li style={{ animationDelay: "0.5s" }}>
            <Link to="/agenda" onClick={toggleMenu}>
              Agenda
            </Link>
          </li>
          <li style={{ animationDelay: "0.6s" }}>
            <Link to="/entitats" onClick={toggleMenu}>
              Entitats
            </Link>
          </li>
          <li style={{ animationDelay: "0.7s" }}>
            <Link to="/botiga" onClick={toggleMenu}>
              Marxandatge
            </Link>
          </li>
          <li style={{ animationDelay: "0.7s" }}>
            <Link to="/contact" onClick={toggleMenu}>
              Contacte
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Menu;
